// src/admin/components/HomePageConfig/LayoutSettings.jsx
import React from "react";
import ColorPicker from "./ColorPicker";

export default function LayoutSettings({ backgroundColor, setBackgroundColor, layoutOrder, setLayoutOrder }) {
  
  const handleBackgroundColorChange = (value) => {
    if (value === "transparent" || value === "") {
      setBackgroundColor("transparent");
    } else {
      setBackgroundColor(value);
    }
  };
  
  return (
    <div className="hcfg-card">
      <div className="hcfg-headrow">
        <h3>Appearance & Layout order</h3>
      </div>
      <div className="hcfg-row">
        <div className="hcfg-col">
          <ColorPicker
            label="Background color"
            value={backgroundColor}
            onChange={handleBackgroundColorChange}
            description="Set to 'transparent' for no background color"
            allowTransparent={true}
          />
        </div>
        <div className="hcfg-col">
          {Object.keys(layoutOrder).map((key) => (
            <div key={key} style={{ marginBottom: "10px" }}>
              <label>{key.replace(/([A-Z])/g, " $1")} order</label>
              <input
                type="number"
                value={layoutOrder[key]}
                onChange={(e) =>
                  setLayoutOrder((prev) => ({
                    ...prev,
                    [key]: Number(e.target.value || 0),
                  }))
                }
                style={{ width: "100%", padding: "8px" }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}